import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { Container, Divider } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import useApiLoading from "hooks/useApiLoading"
import TopContents from "organisms/common/TopContents"
import BottomContents from "organisms/common/BottomContents"

const useStyle = makeStyles(theme => ({
  root: {
    padding: "15px",
    paddingLeft: "30px",
    paddingRight: "30px",
    minHeight: "calc(100vh - 144px)",
    [theme.breakpoints.down("xs")]: {
      minHeight: "calc(100vh - 138px)",
    },
  },
}))

const Contents = ({ location }) => {
  const classes = useStyle()
  const history = useHistory()
  const { isApiLoading } = useApiLoading()
  const pathname = (location && location.state && location.state.pathname) || ""
  const fromTop = pathname === "/" || pathname === "/callback"

  useEffect(() => {
    history.replace("/error", undefined)

    if (!fromTop) {
      history.push("/")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container maxWidth="md" className={classes.root}>
      {!isApiLoading && (
        <>
          <TopContents descriptionId="AgreementSelectionContents.Text3" />
          <Divider />
          <BottomContents />
        </>
      )}
    </Container>
  )
}

export default Contents
